import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const PipelineLaying: React.FC = () => {
  return (
    <>
      <PageHeader title="Pipeline Laying" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Pipeline Laying</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Pipeline laying is a critical part of any water treatment or chemical process infrastructure. It ensures seamless flow of raw water, treated water, effluent, chemicals, steam, and utilities across large plants and industrial facilities. At Wasser Technochem (India) Ltd., we offer end-to-end services for underground and overground pipeline laying, tailored to complex industrial requirements.</p>
              <p>From route planning and material selection to execution and pressure testing, we handle every step with precision, safety, and compliance to industry standards.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-water text-primary me-2"></i>Water intake and distribution pipelines</p>
              <p><i className="fa fa-arrow-down text-primary me-2"></i>Effluent discharge or reuse pipelines</p>
              <p><i className="fa fa-flask text-primary me-2"></i>Chemical transfer and dosing pipelines</p>
              <p><i className="fa fa-fire text-primary me-2"></i>Firewater and utility water lines</p>
              <p><i className="fa fa-compress text-primary me-2"></i>Compressed air, steam, and gas lines</p>
              <p><i className="fa fa-droplet text-primary me-2"></i>Sludge and slurry transfer lines</p>

              <h3 className="mb-4">Our Capabilities</h3>
              
              <h4 className="mb-3"><i className="fa fa-tools text-primary me-2"></i>Material Handling:</h4>
              <p>HDPE, MS, SS, PVC, PP, GRE, FRP, and GI pipelines</p>

              <h4 className="mb-3"><i className="fa fa-road text-primary me-2"></i>Execution of Aboveground & Underground Pipelines:</h4>
              <p>With necessary trenching, bedding, thrust blocks, and supports</p>

              <h4 className="mb-3"><i className="fa fa-tachometer-alt text-primary me-2"></i>Hydraulic Design & Sizing:</h4>
              <p>Ensures minimum head loss and optimal pumping costs</p>

              <h4 className="mb-3"><i className="fa fa-link text-primary me-2"></i>Jointing Techniques:</h4>
              <p>Butt fusion, electrofusion, flanged joints, and solvent welding</p>

              <h4 className="mb-3"><i className="fa fa-search text-primary me-2"></i>Testing & QA:</h4>
              <p>Pressure testing, hydro testing, leak tests, and NDT where required</p>

              <h4 className="mb-3"><i className="fa fa-building text-primary me-2"></i>Support Infrastructure:</h4>
              <p>Valve pits, chambers, anchors, and anti-corrosion protection</p>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Leak-proof, durable, and efficient fluid transport</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Cost-effective layout with minimal bends and losses</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compliance with CPHEEO, IS codes, and BIS standards</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Designed for expansion and future connectivity</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Long-term operational reliability with minimal maintenance</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Successfully executed pipeline projects across industries and infrastructure sectors</p>
              <p><i className="fa fa-star text-warning me-2"></i>Integrated services from design to installation and testing</p>
              <p><i className="fa fa-star text-warning me-2"></i>Capability to handle challenging terrains and industrial environments</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Experience in both new plant pipelines and revamp/retrofit works</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default PipelineLaying;
